var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.04,
    height: 16,
    viewBox: "0 0 18.04 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9616",
    "data-name": "Grupo 9616",
    transform: "translate(-1191.48 -127.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9615",
    "data-name": "Grupo 9615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9612",
    "data-name": "Grupo 9612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11656",
    "data-name": "Caminho 11656",
    d: "M1194.931,127.25h-3.451V130.7h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11657",
    "data-name": "Caminho 11657",
    d: "M1196.971,128.505h12.549v.941h-12.549Z",
    fill: "#415364"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9613",
    "data-name": "Grupo 9613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11658",
    "data-name": "Caminho 11658",
    d: "M1194.931,133.525h-3.451v3.45h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11659",
    "data-name": "Caminho 11659",
    d: "M1196.971,134.779h12.549v.942h-12.549Z",
    fill: "#415364"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9614",
    "data-name": "Grupo 9614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11660",
    "data-name": "Caminho 11660",
    d: "M1194.931,139.8h-3.451v3.451h3.451Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11661",
    "data-name": "Caminho 11661",
    d: "M1196.971,141.054h12.549v.941h-12.549Z",
    fill: "#415364"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid);
export default __webpack_public_path__ + "static/media/icon-grid.0261a92fcba3f79fa7bf6029753d13dd.svg";
export { ForwardRef as ReactComponent };